export default __webpack_public_path__ + "static/images/04dddf0e.png";